import { render, staticRenderFns } from "./AddServicesModalResults.vue?vue&type=template&id=8ef58878&scoped=true&"
import script from "./AddServicesModalResults.vue?vue&type=script&lang=js&"
export * from "./AddServicesModalResults.vue?vue&type=script&lang=js&"
import style0 from "./AddServicesModalResults.vue?vue&type=style&index=0&id=8ef58878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef58878",
  null
  
)

export default component.exports